import { render, staticRenderFns } from "./AbrIndex.vue?vue&type=template&id=fb066056"
import script from "./AbrIndex.vue?vue&type=script&lang=js"
export * from "./AbrIndex.vue?vue&type=script&lang=js"
import style0 from "./AbrIndex.vue?vue&type=style&index=0&id=fb066056&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports